/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/tabindex-no-positive */
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAuth } from './utilities/auth'
import { authHostname } from './api/ApiConfig'

interface IAuthProviderWithNavigate {
    children?: React.ReactNode
}

export const noAuthPages = ['callback', 'terms', 'privacy', 'sme']
export const AuthProviderWithNavigate = ({
    children,
}: IAuthProviderWithNavigate) => {
    const [locationSearchParams, setSearchParams] = useSearchParams()
    const { isAuthenticated, isLoading, loginWithCode, error } = useAuth()
    const page = window.location.pathname.split('/')

    useEffect(() => {
        if (
            locationSearchParams.get('code') !== null &&
            locationSearchParams.get('code') !== '' &&
            !isLoading &&
            error.message === '' &&
            !isAuthenticated
        ) {
            loginWithCode(locationSearchParams.get('code') || '')
        }

        if (!isAuthenticated && !noAuthPages.includes(page[1])) {
            const callback = `${window.location.origin}/callback`

            const searchParams = new URLSearchParams()
            searchParams.append('client_id', 'public-client')
            searchParams.append('redirect_uri', callback)
            searchParams.append('scope', 'openid email profile federated:id')
            searchParams.append('response_type', 'code')
            searchParams.toString()

            sessionStorage.setItem('callbackURL', window.location.href)

            window.location.href = `${authHostname()}/dex/auth?${searchParams.toString()}`
        }
    }, [])

    return (
        <>
            <span />
            {children}
        </>
    )
}
